import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-navy/95 backdrop-blur-md py-4 shadow-lg shadow-navy/20 border-b border-gold-500/10' : 'bg-transparent py-6'}`} data-id="element-204">
      <div className="container mx-auto px-6 flex justify-between items-center" data-id="element-205">
        <div className="font-serif text-2xl font-bold text-cream tracking-wider flex items-center gap-2" data-id="element-206">
          <span className="text-gold-500" data-id="element-207">✦</span>
          La Memoria del Alma
        </div>
        <Button size="sm" onClick={scrollToPricing} className="hidden md:inline-flex" data-id="element-208">
          Acceder Ahora
        </Button>
      </div>
    </motion.nav>;
};